// extracted by mini-css-extract-plugin
export default {"novigateBlock":"top_header_novigateBlock__kx6OC","last":"top_header_last__WlNEw"};